export const CANONICAL_EVENTS = {
  PAGE_VIEWED: "page_viewed",
  SIGNUP_STARTED: "signup_started",
  EMAIL_CLICKED: "email_clicked",
  SIGNUP_COMPLETED: "signup_completed",
  ATTRIBUTION_RECORDED: "attribution_recorded",
  REFERRAL_ATTRIBUTED: "referral_attributed",
  ONBOARDING_COMPLETED: "onboarding_completed",
  VERIFICATION_COMPLETED: "verification_completed",
  CONTENT_UPLOAD_COMPLETED: "content_upload_completed",
  POST_PUBLISHED: "post_published",
  SUBSCRIPTION_PLAN_CREATED: "subscription_plan_created",
  SESSION_RETURNED: "session_returned",
  CONTENT_VIEWED: "content_viewed",
  DASHBOARD_VIEWED: "dashboard_viewed",
  MESSAGE_SENT: "message_sent",
  CHECKOUT_STARTED: "checkout_started",
  PAYMENT_COMPLETED: "payment_completed",
  SUBSCRIPTION_STATUS_CHANGED: "subscription_status_changed",
  CUSTOM_REQUEST_STATUS_CHANGED: "custom_request_status_changed",
  PAYOUT_STATUS_CHANGED: "payout_status_changed",
  EMAIL_SENT: "email_sent",
  EMAIL_OPENED: "email_opened",
  SHARE_CLICKED: "share_clicked",
  SHARE_GENERATED: "share_generated",
  ONBOARDING_STARTED: "onboarding_started",
  PROFILE_COMPLETED: "profile_completed",
  VERIFICATION_STARTED: "verification_started",
  VERIFICATION_STEP_STARTED: "verification_step_started",
  VERIFICATION_STEP_COMPLETED: "verification_step_completed",
  VERIFICATION_ATTEMPT_STARTED: "verification_attempt_started",
  VERIFICATION_FAILED: "verification_failed",
  CONTENT_UPLOAD_STARTED: "content_upload_started",
  SESSION_STARTED: "session_started",
  FEED_ENGAGED: "feed_engaged",
  NOTIFICATION_CLICKED: "notification_clicked",
  OFFER_VIEWED: "offer_viewed",
  PAYMENT_FAILED: "payment_failed",
  PAYMENT_FAILED_PAGE_VIEW: "payment_failed_page_view",
  REFUND_STATUS_CHANGED: "refund_status_changed",
} as const;

export type CanonicalEventName =
  (typeof CANONICAL_EVENTS)[keyof typeof CANONICAL_EVENTS];
